var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 469.28 386.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e4002c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M306,292.9c-.86-47.3-30.41-74.94-92-84,52.15-7.26,82.1-32.88,80-85-5.18-55.19-39.97-85.48-106.13-89.38H.18v26.44c22.85,.11,31.92,8.86,31.82,28.94v235c1.26,25.84-8.11,37.37-32,36l.18,25.74H194.89c71.58-2.17,112.3-27.83,111.11-93.74ZM125,73.84l22,1.06c15.21,1.26,26.16,3.84,32,8,8.34,7.33,13.66,18.68,16,34,1.33,18.19,.11,35.56-4,52-5.12,13.09-16.67,19.87-34,21l-32,1.01V73.84Zm80,247.06c-4.82,17.49-17.49,26.83-39,27l-41,2v-121h23c15.78,.44,29.46,2.5,40,7,13.92,10.49,20.9,26.17,21,47-.37,16.55-1.76,28.96-4,38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M447.77,219.9l5.23-21-14-2c-15.05-1.15-19.16-10.12-15-25L469.28,0h-44.78c-5.95,1.58-10.94,3.63-15.5,5.9l-83,40,4,24,50-17-32,119c-3.58,13.29-12.67,22.1-29,25l-19,2-5,21"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5680fce7ffab0b0a436b8b77353d3738.svg";
export { ForwardRef as ReactComponent };